import React, { useContext } from 'react';
import createDocumentStore from '../store/createDocumentStore';

export const StoreContext = React.createContext<ReturnType<typeof createDocumentStore> | null>(null);

export function useDocumentStore() {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('Rendered outside of store.');
  }
  return store;
}
